export class SlideAction {
  _id: string;
  label: string = '';
  action: string = '';
  position: number = 0;
};



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/home-slider/shared/slide-action.model.ts